import { Contract, ethers } from "ethers";
import { getDecimals } from "../ethereumFunctions";

const STACKING = require("./Stacking.json");
const ERC20 = require("../build/ERC20.json");

export async function parseTokenDecimal(tokenAddress, amount, signer) {
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimal = await getDecimals(token);

  const tokenAmount = ethers.utils.formatUnits(amount, tokenDecimal);

  return +tokenAmount;
}

export async function getTotalPools(contractAddress, signer) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const total = await contract.getTotalPools();

  return +total;
}

export async function getPoolData(contractAddress, signer, contractIndex) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const data = await contract.getPools(contractIndex);

  const info = {
    poolIndex: contractIndex,
    rewardsToken: data[0],
    stakingToken: data[1],
    periodFinish: +data[2],
    rewardRate: +data[3],
    rewardsDuration: +data[4],
    lastUpdateTime: +data[5],
    rewardPerTokenStored: +data[6],
    totalSupply: +data[7],
  };

  return info;
}

export async function addPool(
  contractAddress,
  signer,
  rewardAddress,
  stakeAddress,
  duration
) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const data = await contract.addPool(rewardAddress, stakeAddress, duration);

  console.log(data);
}

export async function stackToken(
  accountAddress,
  tokenAddress,
  amount,
  contractIndex,
  contractAddress,
  signer,
  callback
) {
  // token approve
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimal = await getDecimals(token);

  const tokenAmount = ethers.utils.parseUnits(`${amount}`, tokenDecimal);

  const allowance = await token.allowance(accountAddress, contractAddress);

  if (+allowance < +tokenAmount) {
    await token.approve(contractAddress, tokenAmount);
  }

  let allowanceInterval = setInterval(async () => {
    const allowance_check = await token.allowance(
      accountAddress,
      contractAddress
    );

    if (+allowance_check >= +tokenAmount) {
      clearInterval(allowanceInterval);

      // stack request
      const contract = new Contract(contractAddress, STACKING.abi, signer);

      await contract
        .stake(contractIndex, tokenAmount)
        .then(() => {
          callback({ status: true });
        })
        .catch((e) => {
          callback({ status: false, e });
        });
    }
  }, 5000);
}

export async function getStakedBefore(
  contractAddress,
  contractIndex,
  walletAddress,
  signer
) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const balance = await contract.balanceOf(contractIndex, walletAddress);

  return +balance;
}

export async function getEarned(
  contractAddress,
  contractIndex,
  walletAddress,
  signer
) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const balance = await contract.earned(contractIndex, walletAddress);

  return +balance;
}

export async function harvestToken(contractAddress, contractIndex, signer) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  await contract.getReward(contractIndex);
}

export async function exitStack(contractAddress, contractIndex, signer) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  await contract.exit(contractIndex);
}

export async function withdrawStack(
  tokenAddress,
  amount,
  contractIndex,
  contractAddress,
  signer
) {
  // token approve
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimal = await getDecimals(token);

  const tokenAmount = ethers.utils.parseUnits(`${amount}`, tokenDecimal);

  // withdraw request
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  await contract.withdraw(contractIndex, tokenAmount);
}

export async function setPoolReward(
  accountAddress,
  tokenAddress,
  amount,
  contractIndex,
  contractAddress,
  signer,
  callback
) {
  // token approve
  const token = new Contract(tokenAddress, ERC20.abi, signer);

  const tokenDecimal = await getDecimals(token);

  const tokenAmount = ethers.utils.parseUnits(`${amount}`, tokenDecimal);

  const allowance = await token.allowance(accountAddress, contractAddress);

  if (+allowance < +tokenAmount) {
    await token.approve(contractAddress, tokenAmount);
  }

  let allowanceInterval = setInterval(async () => {
    const allowance_check = await token.allowance(
      accountAddress,
      contractAddress
    );

    if (+allowance_check >= +tokenAmount) {
      clearInterval(allowanceInterval);

      // withdraw request
      const contract = new Contract(contractAddress, STACKING.abi, signer);

      await contract
        .notifyRewardAmount(contractIndex, tokenAmount)
        .then(() => {
          callback({ status: true });
        })
        .catch((e) => {
          callback({ status: false, e });
        });
    }
  }, 5000);

  

}

export async function getOwner(contractAddress, signer) {
  const contract = new Contract(contractAddress, STACKING.abi, signer);

  const owner = await contract.owner();

  return owner;
}
